import React from 'react';
import ReactDOM from 'react-dom';
import AppRoot from './components/AppRoot';
import { IS_DEV } from './environment';
import getOrCreateElementById from './getOrCreateElementById';

const renderAppRoot = () => {
  const appRootElement = getOrCreateElementById('app-root', 'div');

  const render = () => {
    ReactDOM.render(
      <React.StrictMode>
        <AppRoot />
      </React.StrictMode>,
      appRootElement
    );
  };

  document.body.append(appRootElement as HTMLElement);

  // rehydrate on Adobe Target DOM change
  document.addEventListener('at-content-rendering-succeeded', render);

  if (IS_DEV) {
    import('react-axe').then((axe) => {
      // Open console to see accessibility issues
      // @ts-ignore
      // axe(React, ReactDOM, 1000);
    });
  }

  render();
};

export default renderAppRoot;
export { renderAppRoot };
